import Banner from '../../sections/common/banner';
import SectionAchivements1 from '../../sections/home/index2/section-achivements1';
import SectionTestimonials1 from '../../sections/home/index/section-testimonials1';
import SectionCompanyApproch1 from '../../sections/home/index/section-company-approch1';
import { data } from '../../../globals/data/about-us';
import { data as globalData } from '../../../globals/data/home3';
import SectionWhatWeDo2 from '../../sections/home/index3/section-what-we-do2';
import AboutPageHelmet from '../../helmets/AboutPageHelmet';
export default function AboutUsPage() {
  return (
    <>
      <AboutPageHelmet />
      <Banner _data={data.banner} />
      <SectionWhatWeDo2 _data={globalData.whatwedo} />
      <SectionAchivements1 _data={data.achivements} />
      <SectionTestimonials1 _data={data.testimonials} />
      <SectionCompanyApproch1 _data={globalData.approch} />
    </>
  );
}
